import React, { useState, useEffect, useId } from 'react';
import { useNavigate } from 'react-router-dom';
import './Subscription.css';
import ReactCardFlip from "react-card-flip";
import useApi from '../../../../utils/api-manager/Helper/useApi';
import infoIcon from '../../../../assets/Image/info.png';
import infoDark from '../../../../assets/SubscriptionImage/info_dark.png';
import CartIcon from '../../../../assets/SubscriptionImage/add-to-cart (1) 7.png';
import RemoveIcon from '../../../../assets/SubscriptionImage/minus-button 2.png'
import ChequeIcon from '../../../../assets/SubscriptionImage/Cheque.png';
import GasIcon from '../../../../assets/SubscriptionImage/Gas.png';
import LotteryIcon from '../../../../assets/SubscriptionImage/Lottery.png';
import PosIcon from '../../../../assets/SubscriptionImage/Pos.png';
import GeneralIcon from '../../../../assets/SubscriptionImage/General.png';
import ExpenseIcon from '../../../../assets/SubscriptionImage/expense.png';
import InventoryIcon from '../../../../assets/SubscriptionImage/Inventory.png';
import SaleIcon from '../../../../assets/SubscriptionImage/Sale.png';
import PayrollIcon from '../../../../assets/SubscriptionImage/Payroll.png';
import TimeCardIcon from '../../../../assets/SubscriptionImage/TimeCard.png';
import CameraApp from '../../../../assets/SubscriptionImage/CameraIcon.jpg'
import EcommerceLogo from '../../../../assets/SubscriptionImage/e-com.png'
import ArrowDownIcon from '../../../../assets/SubscriptionImage/downIcon.png';
import { renderModuleIcon as renderResolvedModuleIcon } from './moduleIcons';
import PaymentPage from '../SubscriptionUI/PaymentPage';
import useFormattingUtils from '../../../../context/useFormattingUtils';
import { useToastHandler } from "../../../common/ToastHandler";
import { ToastContainer } from 'react-toastify';

const generateSafeId = (name) => {
  return name?.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-_]/g, "") || "";
};

function SubscriptionPage({ inModal = false, onProceedToPayment, storeId }) {
    const reactId = useId();
    const [billingCycle, setBillingCycle] = useState('Monthly');
    const [selectedModules, setSelectedModules] = useState([]);
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [flippedCards, setFlippedCards] = useState({});
    const [moduleSelectedMonths, setModuleSelectedMonths] = useState({});
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedModuleData, setSelectedModuleData] = useState([]);
    const [preparedModuleData, setPreparedModuleData] = useState([]);
    const [selectedModuleIds, setSelectedModuleIds] = useState([]);

    const { handleToast } = useToastHandler();
    const { formatCurrency } = useFormattingUtils();
    const { Get } = useApi();
    const navigate = useNavigate();

    const handleRemoveModule = (moduleName) => {
        setSelectedModules(selectedModules.filter(name => name !== moduleName));
    };

    const HandleNavigate = () => {
        const preparedModuleData = modules.filter(module =>
            selectedModules.includes(module.name)
        ).map(module => {
            const months = moduleSelectedMonths[module.id] || module.price_details[0]?.no_of_months || 1;
            const priceDetail = module.price_details.find(p => p.no_of_months === months);

            return {
                ...module,
                selectedMonths: months,
                priceDetail: {
                    ...priceDetail,
                    total_price: priceDetail?.total_price,
                    days: priceDetail?.days,
                    no_of_months: priceDetail?.no_of_months,
                    id: priceDetail?.id
                },
            };
        });

        if (inModal) {
            onProceedToPayment?.(preparedModuleData);
        } else {
            navigate("/paymentPage", {
                state: {
                    selectedModules: preparedModuleData
                }
            });
        }
    };

    const handlePaymentComplete = () => {
        setShowPaymentModal(false);

        if (selectedModuleData.length > 0) {
            const newFeatures = selectedModuleData.map(m => m.name);
            const existingFeatures = JSON.parse(localStorage.getItem('allowedFeatures')) || [];

            const updatedFeatures = Array.from(new Set([...existingFeatures, ...newFeatures]));
            localStorage.setItem('allowedFeatures', JSON.stringify(updatedFeatures));

            window.dispatchEvent(new Event('allowedFeaturesUpdated'));
        }
    };

    const shouldFilterFeature = (featureTitle, allowedFeatures) => {
        if (allowedFeatures.includes(featureTitle)) {
            return true;
        }

        if (featureTitle.includes('+')) {
            const individualFeatures = featureTitle.split('+').map(f => f.trim());
            const allPartsExist = individualFeatures.every(part =>
                allowedFeatures.some(allowedFeature =>
                    allowedFeature.toLowerCase() === part.toLowerCase()
                )
            );
            return allPartsExist;
        }

        const isPartOfCombined = allowedFeatures.some(allowed => {
            if (allowed.includes('+')) {
                return allowed.toLowerCase().includes(featureTitle.toLowerCase());
            }
            return false;
        });

        return isPartOfCombined;
    };

    useEffect(() => {
        fetchModules();
    }, []);

    const fetchModules = async () => {
        try {
            const response = await Get('featuresWithPrices');
            const allowedFeatures = JSON.parse(localStorage.getItem('allowedFeatures')) || [];

            if (response && response.length > 0) {
                const transformedModules = response
                    .filter(item => {
                        return item.enable && !shouldFilterFeature(item.title, allowedFeatures);
                    })
                    .map(item => {
                        const defaultPriceDetail = item.price_details[0] || {};
                        return {
                            name: item.title,
                            description: item.description || 'No description available',
                            price_details: item.price_details,
                            icon: item.icon,
                            id: item.id,
                            defaultPrice: defaultPriceDetail.total_price || '0.00'
                        };
                    });

                setModules(transformedModules);

                const initialFlippedState = {};
                const initialMonthsState = {};
                transformedModules.forEach(module => {
                    initialFlippedState[module.id] = false;
                    const defaultMonths = module.price_details.find(p => p.no_of_months === 1)
                        ? 1
                        : (module.price_details[0]?.no_of_months || 1);
                    initialMonthsState[module.id] = defaultMonths;
                });
                setFlippedCards(initialFlippedState);
                setModuleSelectedMonths(initialMonthsState);

                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching modules:', error);
            setLoading(false);
        }
    };

    const toggleModule = (moduleName, moduleId) => {
        if (selectedModules.includes(moduleName)) {
            setSelectedModules(selectedModules.filter((m) => m !== moduleName));
            setSelectedModuleIds(selectedModuleIds.filter(id => id !== moduleId));
        } else {
            setSelectedModules([...selectedModules, moduleName]);
            setSelectedModuleIds([...selectedModuleIds, moduleId]);
        }
    };

    const handleFlip = (moduleId, e) => {
        e.stopPropagation();
        setFlippedCards(prev => ({
            ...prev,
            [moduleId]: !prev[moduleId]
        }));
    };

    const handleModuleMonthChange = (moduleId, months) => {
        setModuleSelectedMonths(prev => ({
            ...prev,
            [moduleId]: months
        }));
    };

    const getModulePrice = (module) => {
        const months = moduleSelectedMonths[module.id] || module.price_details[0]?.no_of_months || 1;
        const priceDetail = module.price_details.find(p => p.no_of_months === months);
        return priceDetail?.total_price || '0.00';
    };

    const calculateSubtotal = () => {
        if (!modules.length) return 0;

        return modules
            .filter(module => selectedModules.includes(module.name))
            .reduce((total, module) => {
                const months = moduleSelectedMonths[module.id] || module.price_details[0]?.no_of_months || 1;
                const priceDetail = module.price_details.find(p => p.no_of_months === months);
                return total + parseFloat(priceDetail?.total_price || 0);
            }, 0);
    };

    // Module icons come from the API as a path relative to the backend host
    // (e.g. "/media/subscription_icons/sales.png"). Rendering that path
    // directly as <img src={icon}> resolves it against the frontend's own
    // origin (localhost:3000) instead of the API host, which is why several
    // modules showed as broken images here even though the same icons
    // render fine elsewhere (e.g. the "Switch to another store"/app
    // switcher, which already goes through moduleIcons.js's
    // renderModuleIcon - reuse that here instead of a second, incorrect
    // local implementation, so relative icon paths resolve to the API host
    // and any icon that still fails to load falls back to the bundled
    // local asset instead of a broken image).
    const renderModuleIcon = (moduleName, icon) => renderResolvedModuleIcon(moduleName, icon);

    const getModuleIcon = (moduleName) => {
        switch (moduleName) {
            case 'Lottery':
                return LotteryIcon;
            case 'Timecard + Payroll':
                return PayrollIcon;
            case 'Gas':
                return GasIcon;
            case 'Spends Tracking':
                return ExpenseIcon;
            case 'Sales + Inventory':
                return InventoryIcon;
            case 'Cheque':
                return ChequeIcon;
            case 'Pos':
                return PosIcon;
            case 'General Ledger':
                return GeneralIcon;
            case 'Monitoring':
                return CameraApp;
            default:
                return ChequeIcon;
            case 'Ecommerce':
                return EcommerceLogo;    
        }
    };

    const isModuleSelected = (moduleName) => {
        return selectedModules.includes(moduleName);
    };

    return (
        <div className="subscription-holder">
            {showPaymentModal && (
                <div>
                    <div >
                        {/* <button
                            onClick={() => setShowPaymentModal(false)}
                            style={{
                                position: "absolute",
                                right: "20px",
                                top: "20px",
                                background: "none",
                                border: "none",
                                fontSize: "24px",
                                cursor: "pointer",
                                zIndex: 1
                            }}
                        >
                            ×
                        </button> */}
                        <div >
                            <PaymentPage
                                inModal={true}
                                onComplete={handlePaymentComplete}
                                selectedModules={selectedModuleData}
                                storeId={storeId}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div className="subscription-content">
                <div className="modules-grid-container">
                    <div style={{ marginLeft: '10px', fontWeight: "700",  fontStyle: "bold" }}>
                        <h4>Subscription</h4>
                    </div>
                    <div className="modules-grid">
                        {loading ? (
                            <div>Loading Feature...</div>
                        ) : (
                            modules.map((module) => (
                                <ReactCardFlip
                                    key={module.id}
                                    isFlipped={flippedCards[module.id]}
                                    flipDirection="horizontal"
                                >
                                    <div className="module-box">
                                        <div className="module-header">
                                            <img
                                                src={infoIcon}
                                                alt="Info"
                                                className="info-icon"
                                                onClick={(e) => handleFlip(module.id, e)}
                                            />
                                            <div className="module-header-content">
                                                {renderModuleIcon(module.name, module.icon)}
                                                <span className="module-name">{module.name}</span>
                                            </div>
                                        </div>

                                        <div className="module-bottom">
                                            <div className="module-billing-selector">
                                                <div className="dropdown-payment">
                                                    <select
                                                        value={moduleSelectedMonths[module.id] || 1}
                                                        onChange={(e) => handleModuleMonthChange(module.id, Number(e.target.value))}
                                                        className="dropdown-select"
                                                    >
                                                        {module.price_details.map((priceDetail) => (
                                                            <option key={priceDetail.id} value={priceDetail.no_of_months}>
                                                                {priceDetail.no_of_months} {priceDetail.no_of_months > 1 ? "Months" : "Month"}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <img src={ArrowDownIcon} alt="Select" className="Downarrow" />
                                                </div>
                                                <div className="module-price">
                                                    {formatCurrency(getModulePrice(module))}
                                                </div>
                                            </div>

                                            {isModuleSelected(module.name) ? (
                                                <img
                                                    src={RemoveIcon}
                                                    alt={`Remove ${module.name}`}
                                                    className="cart-icon-bottom"
                                                    data-testid={`remove-${generateSafeId(module.name)}`}
                                                    // data-module-name={module.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleModule(module.name);
                                                    }}
                                                />
                                            ) : (
                                                <img
                                                    src={CartIcon}
                                                    alt={`Add ${module.name}`}
                                                    className="cart-icon-bottom"
                                                    data-testid={`add-${generateSafeId(module.name)}`}
                                                    // data-module-name={module.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleModule(module.name);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="module-box module-box-back">
                                        <div className="module-header">
                                            <img
                                                src={infoDark}
                                                alt="Back"
                                                className="info-icon"
                                                onClick={(e) => handleFlip(module.id, e)}
                                            />
                                        </div>
                                        <div className="module-description-container">
                                            <h3>{module.name}</h3>
                                            <p className="module-description-text">{module.description}</p>
                                        </div>
                                    </div>
                                </ReactCardFlip>
                            ))
                        )}
                    </div>
                </div>


                <div className="payment-holder" style={{ marginRight: '10px' }}>
                    <div className="payment-card">
                        <p className="cart-titles">Cart</p>
                        <p className="price-text">{formatCurrency(calculateSubtotal().toFixed(2))}</p>
                    </div>


                    <div className="selected-module">
                        {selectedModules.length === 0 ? (
                            <p className="no-feature">No feature selected</p>
                        ) : (
                            selectedModules.map((moduleName) => {
                                const moduleData = modules.find(m => m.name === moduleName);
                                if (!moduleData) return null;

                                const months = moduleSelectedMonths[moduleData.id] || 1;
                                const priceDetail = moduleData.price_details.find(p => p.no_of_months === months);
                                const price = priceDetail?.total_price || '0.00';

                                return (
                                    <div key={moduleName} className="module-item" style={{ borderBottom: "1px solid #D5D5D5" }}>
                                        <ToastContainer />
                                        <div className="module-item-content">
                                            <span className="module-item-name">{moduleName}</span>
                                            <span className="module-item-billing">
                                                {priceDetail?.days
                                                    ? `${priceDetail.days} Days`
                                                    : 'N/A'}
                                            </span>
                                            <span className="module-item-price">
                                                {formatCurrency(price)}
                                            </span>
                                        </div>
                                        {/* <div className="module-footer">
                                            <div className="module-footer-line"></div>
                                            <button
                                                className="delete-btn"
                                                onClick={() => handleRemoveModule(moduleName)}
                                            >
                                            </button>
                                        </div> */}
                                    </div>
                                );
                            })
                        )}
                    </div>

                    <div>
                        <button
                            className='subscription-btn'
                            onClick={HandleNavigate}
                            disabled={selectedModules.length === 0}
                        >
                            Go to payment
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionPage;
